import { getSemanticEligibilityScore } from '@mediaingenuity/totallymoney.cardloanutils'

import Text from '@totallymoney/ui/components/Text'

import { ScoredCreditCardProduct } from '@appTypes/EligibilityApi.interface'

import { getDisplayScore } from '@utils/getDisplayScore'
import { getEligibilityArticle } from '@utils/getElgiibilityArticle'

const getEligibleContent = (card: ScoredCreditCardProduct) => {
    const semanticScore = getSemanticEligibilityScore(
        getDisplayScore(card.score)
    )

    if (card.isPreApproved) {
        return <Text variant="120">You’re pre-approved for a {card.name}</Text>
    }

    if (card.score >= 4) {
        return (
            <Text>
                You have {getEligibilityArticle(semanticScore)}{' '}
                {semanticScore?.toLowerCase()} chance of being accepted for{' '}
                {card.name}
            </Text>
        )
    }

    return null
}

export default getEligibleContent
